import { useCallback, useEffect } from 'react';

export default function useDeleteWidget(deleteWidget) {
    const deleteSelectedWidget = useCallback(
        (event) => {
            if (event.keyCode === 46) {
                deleteWidget();
            }
        },
        [deleteWidget]
    );

    useEffect(() => {
        document.addEventListener('keydown', deleteSelectedWidget);

        return () => {
            document.removeEventListener('keydown', deleteSelectedWidget);
        };
    }, [deleteSelectedWidget]);
}
